import { PRICING_REFERENCE_OPTIONS } from '@/src/lib/company-business-units/types';
import { CompanyUserSwitchRequest } from '@/src/lib/company-user/types';

export const PRICING_REFERENCE_NONE = '_';

export function getPatchCompanyUserPayload(pricingReference: string, cartId: string) {
  const companyUserSwitchRequest: CompanyUserSwitchRequest = {
    quoteUuid: cartId,
    priceReferenceProjectNumber: null,
    priceReferenceQuoteId: null,
  };

  if (pricingReference === PRICING_REFERENCE_NONE) {
    return companyUserSwitchRequest;
  }

  if (pricingReference.startsWith(PRICING_REFERENCE_OPTIONS.PROJECT)) {
    companyUserSwitchRequest.priceReferenceProjectNumber = pricingReference
      .split(`${PRICING_REFERENCE_OPTIONS.PROJECT}-`)
      .pop();
  }

  if (pricingReference.startsWith(PRICING_REFERENCE_OPTIONS.QUOTE)) {
    companyUserSwitchRequest.priceReferenceQuoteId = pricingReference
      .split(`${PRICING_REFERENCE_OPTIONS.QUOTE}-`)
      .pop();
  }

  return companyUserSwitchRequest;
}
